/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Document_Not_RetryableInputs */

const en_error_document_not_retryable = /** @type {(inputs: Error_Document_Not_RetryableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The document cannot be asked for again now: it is still waiting in time, or Business Central already numbered it.`)
};

/**
* | output |
* | --- |
* | "The document cannot be asked for again now: it is still waiting in time, or Business Central already numbered it." |
*
* @param {Error_Document_Not_RetryableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_document_not_retryable = /** @type {((inputs?: Error_Document_Not_RetryableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Document_Not_RetryableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_document_not_retryable(inputs)
});